module.exports = __webpack_public_path__ + "static/media/s_v10_18.da50ca0a.mp3";